import { useState, useEffect, useRef, memo } from "react";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import lodash from "lodash";

const ControlledInput = (props) => {
    const [value, setValue] = useState(null);
    const [error, setError] = useState(false);
    const [read, setRead] = useState(true);
    const inputRef = useRef(null);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    useEffect(() => {
        setError(props.error);
    }, [props.error]);

    useEffect(() => {
        setRead(props.read);
    }, [props.read]);

    useEffect(() => {
        if(read !== true) {
            if(props.disabled === true) {
                setValue("");
                if(props.onChange !== undefined) props.onChange("");
                if(!isValid(value)) setError(false);
            } else {
                if(!isValid(props.value)) {
                    if(props.linkPrefill) {
                        // Keep the field empty and focused; the default value is offered as a clickable link instead of being auto-filled.
                        if(inputRef.current) inputRef.current.focus();
                    } else if(props.dependentValue) {
                        props.onChange(props.dependentValue);
                    }
                }
                setError(true);
            }
        }
    }, [props.disabled]);

    const useDefaultValue = () => {
        if(props.dependentValue === undefined || props.dependentValue === null || props.dependentValue === "") return;
        setValue(props.dependentValue);
        props.onChange(props.dependentValue);
        if(inputRef.current) inputRef.current.focus();
    };

    useEffect(() => {
        if(props.setSectionError !== undefined && props.section !== undefined) 
            error ? props.setSectionError((prev) => {
                let newPrev = [...prev];
                newPrev[props.section].push(props.question ? props.question : 'input');
                return newPrev;
            }) : 
            props.setSectionError((prev) => {
                let newPrev = [...prev];
                const index = newPrev[props.section].indexOf(props.question ? props.question : 'input');
                if (index > -1) {
                    newPrev[props.section].splice(index, 1);
                }
                return newPrev;
            });
    }, [error, props.setSectionError]);

    useEffect(() => {
        if(!props.disabled) 
            setError(!isValid(value));
    }, [value, props.validate]);

    const isValid = (value) => {
        return !(value === null || value === "");
    }

    return (
        <>
        {props.value !== undefined ?
            (props.linkPrefill ?
                <Box sx={{ display: "flex", flexDirection: "column", position: 'relative', ...props.sx }}>
                    <TextField
                        error={error && props.validate && !props.disabled}
                        label={props.label}
                        multiline
                        minRows={1}
                        maxRows={20}
                        helperText={props.helperText}
                        value={value}
                        onChange={e => setValue(e.target.value)}
                        onBlur={ e => props.onChange(e.target.value)}
                        variant="standard"
                        fullWidth
                        inputRef={inputRef}
                        inputProps={{...props.inputProps}}
                        disabled={props.disabled}
                        placeholder={props.placeholder}
                    />
                    {read !== true && !props.disabled && !isValid(value) && props.dependentValue ?
                        <Link component="button" type="button" underline="always" onClick={useDefaultValue} sx={{ position: 'absolute', bottom: '-16px', left: 0, fontSize: "0.75rem", color: 'primary.main', zIndex: 10, pointerEvents: 'auto' }}>
                            {props.dependentValue}
                        </Link> :
                        <></>
                    }
                </Box> :
                <TextField
                    error={error && props.validate && !props.disabled}
                    label={props.label}
                    multiline
                    minRows={1}
                    maxRows={20}
                    helperText={props.helperText}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    onBlur={ e => props.onChange(e.target.value)}
                    variant="standard"
                    sx={{...props.sx}}
                    inputProps={{...props.inputProps}}
                    disabled={props.disabled}
                    placeholder={props.placeholder}
                />
            ) :
            <></>
        }
        </>
        
    );
}

export default memo(ControlledInput,
    (prevProps, nextProps) => {
        if(lodash.isEqual(prevProps.sx, nextProps.sx) && lodash.isEqual(prevProps.inputProps, nextProps.inputProps) && lodash.isEqual(prevProps.value, nextProps.value) 
        && lodash.isEqual(prevProps.disabled, nextProps.disabled) && prevProps.onChange == nextProps.onChange && lodash.isEqual(prevProps.placeholder, nextProps.placeholder)
        && lodash.isEqual(prevProps.error, nextProps.error) && lodash.isEqual(prevProps.validate, nextProps.validate) && lodash.isEqual(prevProps.validQuestions, nextProps.validQuestions)
        && lodash.isEqual(prevProps.dependentValue, nextProps.dependentValue) && lodash.isEqual(prevProps.linkPrefill, nextProps.linkPrefill)) {
            return true;
        } else {
            return false;
        }
    }
);
